import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

fetch('assets/config.json')
  .then(response => response.json())
  .then(json => {
    platformBrowserDynamic([
      {
        provide: MSAL_INSTANCE,
        useValue: new PublicClientApplication({
          auth: {
            clientId: json.microsoft365.clientId,
            authority: json.microsoft365.authority,
            redirectUri: json.microsoft365.redirectUri,
          },
          cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
          },
        }),
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useValue: {
          interactionType: InteractionType.Popup,
          authRequest: {
            scopes: ['user.read'],
          },
        } as MsalGuardConfiguration,
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useValue: {
          interactionType: InteractionType.Popup,
          protectedResourceMap: new Map(json.microsoft365.protectedResourceMap),
        } as MsalInterceptorConfiguration,
      },
    ])
      // TODO: migrate to bootstrapApplication() when converting to standalone
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
